import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Consumption,
  ConsumptionMinimal,
  GovSupport
} from './consumption.types';
import { Observable } from 'rxjs';

// Nytt forbruksapi med cachede timeverdier

@Injectable({
  providedIn: 'root'
})
export class ConsumptionService {
  rootUrl = 'https://appgw.prod.iktest.co/api-app/consumption';

  constructor(private _httpClient: HttpClient) {}

  getConsumptionMonth(
    objectid: string,
    yearmonth: string
  ): Observable<Consumption[]> {
    const params = new HttpParams()
      .append('period', yearmonth) // YYYYMM
      .append('resolution', 'M');
    const path = `${this.rootUrl}/${objectid}`;
    return this._httpClient.get<Consumption[]>(path, { params });
  }

  getConsumptionDays(
    objectid: string,
    yearmonth: string
  ): Observable<Consumption[]> {
    const params = new HttpParams()
      .append('period', yearmonth) // YYYYMM
      .append('resolution', 'D');
    const path = `${this.rootUrl}/${objectid}`;
    return this._httpClient.get<Consumption[]>(path, { params });
  }

  getConsumptionHours(
    objectid: string,
    yearmonth: string // YYYYMM
  ): Observable<Consumption[]> {
    const path = `${this.rootUrl}/${objectid}/${yearmonth}/H`;
    return this._httpClient.get<Consumption[]>(path);
  }

  getConsumptionHoursOld(): Observable<ConsumptionMinimal[]> {
    const headers = new HttpHeaders({
      'X-Fields':
        '{kunde_id, fk_salgsordre, objectid, prisomrade, parts{period, consumption, real_price}}'
    });
    const path = `${this.rootUrl}/*/H`;
    return this._httpClient.get<ConsumptionMinimal[]>(path, { headers });
  }

  getConsumptionHoursPriceAbove(
    price: number
  ): Observable<ConsumptionMinimal[]> {
    const headers = new HttpHeaders({
      'X-Fields':
        '{kunde_id, fk_salgsordre, objectid, prisomrade, parts{period, consumption, real_price}}'
    });
    const path = `${this.rootUrl}/*/H/real_price/above/${price}`;
    return this._httpClient.get<ConsumptionMinimal[]>(path, { headers });
  }

  getConsumptionSmartnessDays(): Observable<Consumption[]> {
    const path = `${this.rootUrl}/*/D/smartness/above/0.0`;
    return this._httpClient.get<Consumption[]>(path);
  }

  getConsumptionUnsmartnessDays(): Observable<Consumption[]> {
    const path = `${this.rootUrl}/*/D/smartness/below/0.0`;
    return this._httpClient.get<Consumption[]>(path);
  }

  getGovSupportCurrentMonth(objectid: string): Observable<GovSupport[]> {
    const path = `${this.rootUrl}/govsupport/${objectid}/0`;
    return this._httpClient.get<GovSupport[]>(path);
  }

  getGovSupport(
    objectid: string,
    year: number,
    month: number
  ): Observable<GovSupport[]> {
    const period = year.toString() + month.toString().padStart(2, '0');
    const path = `${this.rootUrl}/govsupport/${objectid}/${period}`;
    return this._httpClient.get<GovSupport[]>(path);
  }
}
